import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUser } from '../../redux/loginReducer';
import { ThemeContext } from './../../Context/ThemeContext';
import logo from './../../assets/images/chapado.png';
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
export default function Login({ onClose }) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { LoginRequest } = useContext(ThemeContext);
  const loginState = useSelector(state => state.login ||{});

 
  const { error, mensagem, loading, isLoggedIn } = loginState;

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(getUser({ email, senha }));
  };
  console.log(isLoggedIn)


  useEffect(() => {
    if (isLoggedIn) {

       // Salva temporariamente na sessionStorage (dura até fechar a aba)
    sessionStorage.setItem('isLoggedIn', 'true');
    
      if (onClose) onClose();
      setEmail('');
      setSenha('');
      setTimeout(() => navigate('/admin/cardapio'), 100);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    axios.get('https://congolinaria.com.br/api/login_background.php')
      .then(res => {
        if (res.data?.imagem) {
          setBackgroundImage(`https://congolinaria.com.br/${res.data.imagem}`);
        }
      })
      .catch(err => console.error('Erro ao carregar imagem de fundo:', err));
  }, []);

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-gray-100 px-4"
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}
    >
      <div className="bg-white bg-opacity-95 rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <button className="absolute top-2 right-2 text-gray-500 hover:text-red-600" onClick={onClose}>×</button>

        <div className="flex justify-center mb-6">
          <img src={logo} alt="Logo" className="w-24 h-24 object-contain" />
        </div>

        {mensagem && error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4">
            {mensagem}
          </div>
        )}
        {mensagem && !error && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded mb-4">
            {mensagem}
          </div>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative">
            <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
              inputMode="email"
              spellCheck={false}
              className="w-full pl-10 p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-yellow-400 normal-case"
              required
            />
          </div>

          <div className="relative">
            <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type={mostrarSenha ? "text" : "password"}
              placeholder="Digite sua senha"
              value={senha}
              onChange={e => setSenha(e.target.value)}
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              className="w-full pl-10 pr-10 p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-yellow-400 normal-case"
              required
            />
            <span
              onClick={() => setMostrarSenha(!mostrarSenha)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
            >
              {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-3 rounded transition duration-300"
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="mt-4 text-center text-sm text-gray-600">
          Não tem uma conta?{' '}
          <span
            onClick={() => navigate("/register/")}
            className="text-blue-600 hover:underline cursor-pointer"
          >
            Registre-se
          </span>
        </div>
      </div>
    </div>
  );
}
